import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=7cfaf55a&scoped=true"
import script from "./TermsOfService.vue?vue&type=script&lang=ts"
export * from "./TermsOfService.vue?vue&type=script&lang=ts"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=7cfaf55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfaf55a",
  null
  
)

export default component.exports